import { useState } from 'react'
import { LazyMount } from '@app/components/lazy/lazymount'
import { Analytic } from '@app/types'
import { dataListStyle } from '../../cells/card/head-style'
import { PageIssuesBar } from '../../lists/render/issues/issues-bar'
import { RenderInnerAnalyticsPagingMock } from './analytics-paging-mock'

type IssueCardProps = {
  pageUrl: string
  liveData?: Analytic[]
  activeSubscription?: boolean
  domain?: string
}

// issue card paging
export const IssueCardMock = ({
  pageUrl,
  liveData,
  activeSubscription,
  domain,
}: IssueCardProps) => {
  const [extraActive, setExtraActive] = useState<boolean | string>(false)
  const [filterActive, setFilterActive] = useState<'errors' | 'warnings'>()

  return (
    <div>
      <PageIssuesBar
        active={extraActive}
        setExtraActive={setExtraActive}
        activeSubscription={activeSubscription}
        setFilterActive={setFilterActive}
        filterActive={filterActive}
        pageUrl={pageUrl}
      />
      <div>
        <LazyMount className={dataListStyle}>
          <RenderInnerAnalyticsPagingMock
            pageUrl={pageUrl}
            liveData={liveData}
            extraActive={extraActive}
            domain={domain}
            filterActive={filterActive}
          />
        </LazyMount>
      </div>
    </div>
  )
}
